import { Primary16SemiBold, Box, Flex } from '@sequencehq/core-components'
import { useBillingScheduleId } from 'modules/BillingScheduleHome/utils/useBillingScheduleId'
import { useBillingScheduleAggregate } from 'BillingScheduleHome/utils/useBillingScheduleAggregate'
import { AttachmentsCarousel } from 'Assets/Attachments'

const useAttachmentsSection = () => {
  const billingScheduleId = useBillingScheduleId()
  const billingScheduleAggregateQuery = useBillingScheduleAggregate({
    billingScheduleId,
    select: data => {
      return {
        attachments: data.billingSchedule.attachmentAssets
      }
    }
  })

  return {
    isLoading: billingScheduleAggregateQuery.isPending,
    isError: billingScheduleAggregateQuery.isError,
    attachments: billingScheduleAggregateQuery.data?.attachments ?? []
  }
}

const AttachmentsTitle = () => (
  <Box {...Primary16SemiBold} marginBottom="16px">
    Attachments
  </Box>
)

export const ScheduleAttachmentsSection = () => {
  const { attachments } = useAttachmentsSection()

  if (attachments.length === 0) {
    return null
  }

  return (
    <Flex flexDirection="column" gap="8px" data-testid="schedule.attachments">
      <AttachmentsTitle />
      <AttachmentsCarousel
        attachments={attachments}
        testIdPrefix="schedule.attachments."
      />
    </Flex>
  )
}
